import { DesktopMessage } from './Notification/DesktopMessage';
import { MobileMessage } from './Notification/MobileMessage';

export const componentsConfig = {
  DesktopMessage,
  MobileMessage
};
